export const getScoreColor = (v: number, max = 100): string => {
  const pct = (v / max) * 100
  if (pct >= 80) return '#f05a22'
  if (pct >= 60) return '#31afb4'
  if (pct >= 40) return '#e8a020'
  return '#8a8a8a'
}

/** Calendar stakes — distinct purple scale (not shared with pick/chip metrics). */
export const getGameweekStakesColor = (stakes: number): string => {
  const pct = stakes * 10
  if (pct >= 80) return '#7c6bcf'
  if (pct >= 60) return '#8f83d6'
  if (pct >= 40) return '#a399de'
  return '#b8b0e6'
}
